export default __webpack_public_path__ + "static/media/detail_small_2_4.49142d1f.png";